var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "as-time-line-wrap" }, [
    _vm.timeRes.IsShow
      ? _c("div", { staticClass: "flex-row-start-center" }, [
          _c("span", [_vm._v("商家处理时效：")]),
          _vm._v(" "),
          _vm.timeRes.Status >= 23
            ? _c("span", [_vm._v("已处理完成")])
            : _vm.timeRes.timeOut
            ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("已超时")])
            : _vm.timeRes.countDownTime
            ? _c("div", [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    _vm._s(_vm.timeRes.StatusStr) +
                      "   " +
                      _vm._s(_vm.timeRes.countDownTime)
                  )
                ]),
                _c("span", [_vm._v("后，即将逾期售后")])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7819e915", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7819e915","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aftersale/as-time-line.vue
// module id = null
// module chunks = 